import React, { useState } from 'react';
import { Box } from '@mui/material';
import COLORS from '../../../../constants/colors'; // Import colors
import logo from "../../../../assets/logo.png"; // Import your logo


const Header = ({ mode }) => {
  const [drawerOpen, setDrawerOpen] = useState(false); // Manage side nav drawer state

  return (
    <>
      {/* Header */}
      <Box
        sx={{
          backgroundColor: COLORS.white,
          backdropFilter: 'blur(20px)',
          WebkitBackdropFilter: 'blur(10px)',
          color: 'text.primary',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          padding: '15px 20px',
          position: 'sticky',
          top: 0,
          zIndex: 1000,
          paddingY: 2,
          pt: 2,
          paddingX: { xs: 2, sm: 4, md: 8 },
          flexDirection: { xs: 'row', sm: 'row' },
        }}
      >
        {/* Left Section: Logo Image */}
       <Box sx={{ display: 'flex', alignItems: 'center' }}>
         <Box
           component="img"
           src={logo}
           alt="Yamba Logo"
           sx={{
             height: 40, // Adjust height as needed
             width: 'auto',
             objectFit: 'contain',
             cursor: 'pointer',
           }}
         />
       </Box>



      </Box>

    </>
  );
};

export default Header;
